module.exports = __webpack_public_path__ + "static/media/no-videos-illustration-min.7ead484f.png";